import { graphql } from 'react-relay';

export const updatePaymentCard = graphql`
  mutation updatePaymentCardMutation($updatePaymentCardInput: PaymentCardInfoInput!) {
    updatePaymentCard(updatePaymentCardInput: $updatePaymentCardInput) {
      result
      errors {
        code
        message
      }
    }
  }
`;
